import React, { useState, useEffect } from 'react';
import './MobileSettings.css';
import AccountSelector from './AccountSelector';

function MobileSettings({ selectedExchanges, onExchangeToggle, accounts, selectedAccountId, onSelectAccount, accountsLoading, onManageAccount, onLogout }) {
  const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
    const saved = localStorage.getItem('notificationsEnabled');
    return saved === 'true';
  });
  const [showExchangeFilters, setShowExchangeFilters] = useState(false);

  // Save notifications preference
  useEffect(() => {
    localStorage.setItem('notificationsEnabled', String(notificationsEnabled));
  }, [notificationsEnabled]);

  const handleExchangeToggle = (exchange) => {
    if (onExchangeToggle) {
      onExchangeToggle(exchange);
    }
  };

  const exchanges = [
    { key: 'binance', label: 'Binance' },
    { key: 'bybit', label: 'Bybit' },
    { key: 'okx', label: 'OKX' },
    { key: 'hyperliquid', label: 'Hyperliquid' },
    { key: 'lighter', label: 'Lighter' },
    { key: 'extended', label: 'Extended' }
  ];

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to log out?')) {
      if (onLogout) {
        onLogout();
      } else {
        // Default logout behavior - clear localStorage and reload
        localStorage.clear();
        window.location.reload();
      }
    }
  };

  return (
    <div className="mobile-settings">
      <h1 className="mobile-header">Menu</h1>

      {/* Team Section – current team + switch (same as funds.frasyndicate) */}
      <section className="settings-section mobile-team-section">
        <h2 className="section-title">Team</h2>
        <div className="mobile-team-selector">
          <AccountSelector
            accounts={accounts || []}
            selectedAccountId={selectedAccountId}
            onSelect={onSelectAccount}
            onManageAccount={onManageAccount}
            accountsLoading={!!accountsLoading}
          />
        </div>
      </section>

      {/* Preferences Section */}
      <section className="settings-section">
        <h2 className="section-title">Preferences</h2>
        
        <div className="settings-item">
          <div className="settings-item-content">
            <span className="settings-icon">🔀</span>
            <span className="settings-label">Exchange Filters</span>
          </div>
          <button 
            className="settings-toggle-button"
            onClick={() => setShowExchangeFilters(!showExchangeFilters)}
          >
            {showExchangeFilters ? 'Hide' : 'Show'}
          </button>
        </div>

        {showExchangeFilters && (
          <div className="exchange-filters-list">
            {exchanges.map(ex => (
              <div key={ex.key} className="exchange-filter-item">
                <span className="exchange-filter-label">{ex.label}</span>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={selectedExchanges[ex.key] || false}
                    onChange={() => handleExchangeToggle(ex.key)}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        )}

        <div className="settings-item">
          <div className="settings-item-content">
            <span className="settings-icon">🔔</span>
            <span className="settings-label">Notifications</span>
          </div>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={notificationsEnabled}
              onChange={(e) => setNotificationsEnabled(e.target.checked)}
            />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </section>

      {/* Account Section */}
      <section className="settings-section">
        <h2 className="section-title">Account</h2>

        <a
          href="https://funds.frasyndicate.com/admin/account"
          target="_blank"
          rel="noopener noreferrer"
          className="settings-nav-item settings-nav-link"
        >
          <div className="settings-item-content">
            <span className="settings-icon">🔗</span>
            <span className="settings-label">Manage account (Fund Transfer Service)</span>
          </div>
          <span className="nav-arrow">›</span>
        </a>
        
        <button className="settings-nav-item">
          <div className="settings-item-content">
            <span className="settings-icon">👤</span>
            <span className="settings-label">Profile</span>
          </div>
          <span className="nav-arrow">›</span>
        </button>

        <button className="settings-nav-item">
          <div className="settings-item-content">
            <span className="settings-icon">❓</span>
            <span className="settings-label">Help & Support</span>
          </div>
          <span className="nav-arrow">›</span>
        </button>

        <button className="settings-nav-item disabled">
          <div className="settings-item-content">
            <span className="settings-icon">⚙️</span>
            <span className="settings-label">Advanced Settings (Admin)</span>
          </div>
          <span className="nav-arrow">›</span>
        </button>
      </section>

      {/* Log Out Button */}
      <button className="logout-button" onClick={handleLogout}>
        Log Out
      </button>
    </div>
  );
}

export default MobileSettings;

